(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["affari-billing"]) return;
  try {
    
(() => {
  const initialize = () => document.querySelectorAll('[data-billing-form]').forEach(form => {
    if(form.dataset.initialized) return;
    form.dataset.initialized='true';
    const q = s => form.querySelector(s);
    const all = s => [...form.querySelectorAll(s)];
    const country=q('#billing-country');
    country.value=form.dataset.savedCountry;
    if(!country.value) country.value='Italy';
    const delivery=q('#billing-delivery');
    delivery.value=form.dataset.savedRecapito || 'Non specificato';
    if(!delivery.value) delivery.value='Non specificato';
    const button=q('[name=checkout]');
    const status=q('[data-billing-status]');
    let busy=false;
    function update(){
      const type=q('input[type=radio]:checked').value;
      const business=type!=='Privato';
      const invoice=business||q('[data-request-invoice]').checked;
      const italy=country.value==='Italy';
      const show=(s,value)=>all(s).forEach(e=>e.hidden=!value);
      show('[data-private]',!business);
      show('[data-business]',business);
      show('[data-invoice-fields]',invoice);
      show('[data-person]',type!=='Società');
      show('[data-company]',type==='Società');
      show('[data-italy]',italy);
      show('[data-sdi]',delivery.value==='Codice SDI');
      show('[data-pec]',delivery.value==='Indirizzo PEC');
      show('[data-address]',!q('[data-same-address]').checked);
      q('[data-invoice-value]').value=invoice?'Sì':'No';
      q('[data-address-value]').value=invoice?(q('[data-same-address]').checked?'Indirizzo di fatturazione del checkout':'Indirizzo indicato nei dati fiscali'):'';
      all('[data-attribute]').forEach(input=>{
        input.disabled=!!input.closest('[hidden]');
        input.required=!input.disabled&&input.dataset.required==='true';
        input.setCustomValidity('');
      });
      q('#billing-tax').required=invoice&&type!=='Società'&&italy;
      q('#billing-tax').closest('.affari-billing__field').querySelector('[data-required-mark]').hidden=!italy;
      button.disabled=busy||button.dataset.canContinue!=='true';
    }
    function normalize(input){
      input.value=input.value.trim();
      if(['billing-tax','billing-company-tax','billing-vat','billing-sdi'].includes(input.id)) input.value=input.value.replace(/\s/g,'').toUpperCase();
      if(input.id==='billing-vat'&&country.value==='Italy') input.value=input.value.replace(/^IT/,'');
    }
    function validate(input){
      input.setCustomValidity('');
      if(input.disabled) return;
      const value=input.value.trim();
      if(input.required&&!value){input.setCustomValidity(form.dataset.requiredError);return;}
      if(!value) return;
      const italy=country.value==='Italy';
      if(italy&&input.id==='billing-vat'&&!/^\d{11}$/.test(value)) input.setCustomValidity(form.dataset.vatError);
      if(italy&&input.id==='billing-tax'&&!/^[A-Z]{6}[0-9LMNPQRSTUV]{2}[A-Z][0-9LMNPQRSTUV]{2}[A-Z][0-9LMNPQRSTUV]{3}[A-Z]$/.test(value)) input.setCustomValidity(form.dataset.taxError);
      if(italy&&input.id==='billing-company-tax'&&!/^(\d{11}|[A-Z]{6}[0-9LMNPQRSTUV]{2}[A-Z][0-9LMNPQRSTUV]{2}[A-Z][0-9LMNPQRSTUV]{3}[A-Z])$/.test(value)) input.setCustomValidity(form.dataset.taxError);
      if(input.id==='billing-sdi'&&!/^[A-Z0-9]{7}$/.test(value)) input.setCustomValidity(form.dataset.sdiError);
      if(italy&&input.id==='billing-postcode'&&!/^\d{5}$/.test(value)) input.setCustomValidity(form.dataset.postcodeError);
    }
    form.addEventListener('change',update);
    form.addEventListener('input',event=>event.target.setCustomValidity?.(''));
    form.addEventListener('focusout',event=>{if(event.target.matches('[data-attribute]')){normalize(event.target);validate(event.target);}});
    form.addEventListener('submit',async event=>{
      event.preventDefault();
      if(busy||button.dataset.canContinue!=='true') return;
      all('[data-attribute]').forEach(input=>{normalize(input);validate(input);});
      if(!form.reportValidity()) return;
      busy=true;button.disabled=true;status.setAttribute('role','status');status.textContent=form.dataset.saving;
      const attributes={};
      all('[data-attribute]').forEach(input=>{attributes[input.dataset.attribute]=input.disabled?'':input.value;});
      for(const [name,value] of new FormData(form)){
        const key=name.match(/^attributes\[(.+)\]$/)?.[1];
        if(key) attributes[key]=value;
      }
      attributes['Passaggio dati fatturazione']='Completato';
      try{
        const response=await fetch(form.dataset.updateUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({attributes}),credentials:'same-origin'});
        if(!response.ok) throw new Error('save');
        const cart=await response.json();
        if(!cart.item_count||Object.entries(attributes).some(([key,value])=>value&&(cart.attributes?.[key]!==value))) throw new Error('verify');
        status.textContent=form.dataset.ready;
        const checkout=document.createElement('input');checkout.type='hidden';checkout.name='checkout';checkout.value='1';form.append(checkout);
        HTMLFormElement.prototype.submit.call(form);
      }catch{
        busy=false;button.disabled=false;status.setAttribute('role','alert');status.textContent=form.dataset.error;status.focus();
      }
    });
    update();
    window.addEventListener('pageshow',()=>{busy=false;update();status.textContent='';});
  });
  initialize();document.addEventListener('shopify:section:load',initialize);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["affari-cart"]) return;
  try {
    
document.addEventListener('submit',async event=>{
  const form=event.target;
  const button=event.submitter;
  if(!form.matches('.affari-cart__form')||button?.name!=='return_to') return;
  event.preventDefault();
  if(form.dataset.saving) return;
  form.dataset.saving='true';button.disabled=true;
  const error=form.querySelector('[data-cart-billing-error]');error.hidden=true;
  try{
    const url=new URL(form.action);url.pathname=url.pathname.replace(/\/$/,'')+'/update.js';url.search='';
    const response=await fetch(url,{method:'POST',body:new FormData(form),credentials:'same-origin',headers:{Accept:'application/json'}});
    if(!response.ok) throw new Error('save');
    await response.json();
    window.location.assign(button.value);
  }catch{delete form.dataset.saving;button.disabled=false;error.hidden=false;}
},true);
window.addEventListener('pageshow',()=>document.querySelectorAll('.affari-cart__form[data-saving]').forEach(form=>{delete form.dataset.saving;form.querySelector('[name=return_to]').disabled=false;}));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
